import { combineReducers } from 'redux';
import clients from './clients';
import filters from './filters';

export default combineReducers({
    clients,
    filters
});
